import React from "react";
import {
	Tooltip, 
	Button,
	Row,
	Col,
	Form,
	DatePicker,
} from 'antd';
import FullCalendar from "@fullcalendar/react";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import '../../scss/mixin.css'
import './AuthorisedOfficer.css'
import {connect} from "react-redux";

const currentDate = new Date();
let borderCount = 1;

class RecentActivityCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      manSolAssignedTeam: [],
      selectedHeader: "resourceTimeGridWeek",
      defaultDate: currentDate,
      endDate: currentDate,
    };
  };

  componentDidMount() {
    // let myInterval = setInterval(()=>{
    //   if(sessionStorage.getItem('customer_id') ){
    //     let customer_id = sessionStorage.getItem('customer_id');
    //     this.props.dispatch({type:'RECENT_ACTIVITY_CALENDAR_REQUEST',customer_id});
    //     clearInterval(myInterval);
    //   }
    // }, 500);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, fieldsValue) => {
      if (!err) {
        this.setState({ defaultDate: fieldsValue["start_date"].format("YYYY-MM-DD") });
      }
    });
  };

  handleCalendarDates = (startDate, endDate) => {
    if (sessionStorage.getItem('customer_id')) {
      let customer_id = sessionStorage.getItem('customer_id');
      const calendarData = {
        customer_id: customer_id,
        start_date: startDate,
        end_date: endDate,
      };

      this.props.dispatch({
        type:'RECENT_ACTIVITY_CALENDAR_REQUEST', 
        calendarData
      });

      const payload = {
        startDate: startDate,
        endDate: endDate,
      }
      this.props.dispatch({
        type:'SAVE_CALENDAR_REQUEST',
        payload
      });
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 3, offset: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 10 }
      }
    };

    return (
      <div>
        <div className="marginTop"/>
        <div className="container">
          <div className="panel panel-success">
            <div
                className="panel-heading">
                < h3 className="panel-title"> Recent Activity Calendar</h3>
            </div>
            <Row>
              <Col>
                <Form 
                  {...formItemLayout} 
                  onSubmit={this.handleSubmit}
                >
                  {this.state.selectedHeader === "resourceTimeGridWeek" ? (
                    <Form.Item label={"Date"}>
                      {getFieldDecorator("start_date", {
                        initialValue: moment(this.state.defaultDate, "DD/MM/YYYY"),
                        rules: [{ required: true, message: "Please input date." }]
                      })(<DatePicker.WeekPicker format={"DD/MM/YYYY"} />)}
                      <Button
                        size={"small"}
                        type="primary"
                        htmlType="submit"
                        id={"subbb"}
                        style={{ marginLeft: 8 }}
                      >
                        Show
                      </Button>
                    </Form.Item>
                  ) : (
                    <Form.Item label={"Date"}>
                      {getFieldDecorator("start_date", {
                        initialValue: moment(currentDate, "DD/MM/YYYY"),
                        rules: [{ required: true, message: "Please input date." }]
                      })(
                        <DatePicker
                          format={"DD/MM/YYYY"}
                          onChange={(date, dateString) => {
                            if (this.state.selectedHeader === "resourceTimeGridTenDay") {
                              this.setState({ endDate: moment(date, "YYYY-MM-DD").add(14, "days") })
                            } else {
                              this.setState({ endDate: date })
                            }
                          }}
                        />
                      )}
                      <Button
                        size={"small"}
                        type="primary"
                        htmlType="submit"
                        id={"subbb"}
                        style={{ marginLeft: 8 }}
                      >
                        Show
                      </Button>
                    </Form.Item>
                  )}
                </Form>
              </Col>
              <Col
                span={22}
                offset={1}
              >
                <FullCalendar
                  key={this.state.defaultDate}
                  locale={"en-AU"}
                  timeZone="Australia/Brisbane"
                  titleFormat={{
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    locale: "en-AU",
                    omitCommas: true
                  }}
                  plugins={[resourceTimeGridPlugin, interactionPlugin]}
                  initialView={this.state.selectedHeader}
                  views={{
                    resourceTimeGridTenDay: {
                      type: "resourceTimeGrid",
                      duration: { days: 14 },
                      buttonText: "fortnight"
                    },
                  }}
                  headerToolbar={{
                    left: "resourceTimeGridDay,resourceTimeGridWeek,resourceTimeGridTenDay",
                    center: "title",
                    right: "prev,next"
                  }}
                  datesAboveResources={true}
                  resources={
                    this.props.recentActivityCalendarData &&
                    this.props.recentActivityCalendarData.resources
                  }
                  events={
                    this.props.recentActivityCalendarData &&
                    this.props.recentActivityCalendarData.summary2
                  }
                  eventOverlap={false}
                  eventContent={(info) => {
                    const el = info.el;
                    const content = (
                      <Tooltip
                        title={
                          <span
                            dangerouslySetInnerHTML={{
                              __html: info.event.extendedProps.description
                            }}
                          />
                        }
                      >
                        <div className="fc-event-main">
                          <div className="fc-event-title">{info.event._def.title}</div>
                        </div>
                      </Tooltip>
                    );
                    return content;
                  }}
                  datesSet={(info) => {
                    this.setState({ selectedHeader: info.view.type });
                    this.handleCalendarDates(
                      moment(new Date(info.view.activeStart)).format("DD/MM/YYYY"),
                      moment(new Date(info.view.activeEnd)).format("DD/MM/YYYY")
                    );
                  }}
                  slotEventOverlap={false}
                  initialDate={this.state.defaultDate}
                  schedulerLicenseKey={"GPL-My-Project-Is-Open-Source"}
                  scrollTime={"07:00:00"}
                  displayEventTime={false}
                  selectable={true}
                  select={info => {
                    const startDate = moment(info["startStr"]);
                    const endDate = moment(info["endStr"]);
                    const duration = endDate.diff(startDate, "hours", true);
                  }}
                  aspectRatio={2}
                  datesRender={info => {
                    console.log("infocportal", info)
                    handleCalendarDates(
                      moment(new Date(info.view.activeStart)).format("DD/MM/YYYY"),
                      moment(new Date(info.view.activeEnd)).format("DD/MM/YYYY")
                    );

                    setSelectedHeader(info.view.type);
                    const currDate = moment(
                      new Date(info.view.activeStart),
                      "DD/MM/YYY"
                    );
                    const endDate = moment(
                      new Date(info.view.activeEnd),
                      "DD/MM/YYY"
                    );
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
      recentActivityCalendarData: state.recentActivityCalendarState.recentActivityCalendarData,
  };
}
const RecentActivityCalendarForm = Form.create()(RecentActivityCalendar);

export default connect(mapStateToProps)(RecentActivityCalendarForm);
